module.exports = __webpack_public_path__ + "static/media/DOCUMENTOS TRAMITES.fe70b773.pdf";